import React from "react";
import SearchableSelect from "./SearchableSelect";

/**
 * Program + Hosted By toolbar controls. Match Event Management Events filters.
 */
export default function EventProgramHostedByFilters({
  programs,
  filterProgramId,
  onProgramChange,
  filterOrganizerId,
  onOrganizerChange,
  filterProgramMembers,
}) {
  return (
    <>
      <span className="toolbar-label">Program</span>
      <div className="input-min-160" style={{ minWidth: 160 }}>
        <SearchableSelect
          value={filterProgramId}
          onChange={(v) => onProgramChange(String(v || ""))}
          options={(programs || []).map((g) => ({
            value: String(g._id),
            label: String(g?.name || "Program"),
          }))}
          placeholder="— All —"
          searchPlaceholder="Search program…"
          allowEmpty={true}
          emptyLabel="— All —"
          maxVisibleItems={4}
          dropdownPortal={true}
          title="Program filter"
        />
      </div>
      <span className="toolbar-label">Hosted By</span>
      <div className="input-min-160" style={{ minWidth: 160 }}>
        <SearchableSelect
          value={filterOrganizerId}
          onChange={(v) => onOrganizerChange(String(v || ""))}
          options={(filterProgramMembers || []).map((m) => {
            const label = [m?.first_name, m?.last_name].filter(Boolean).join(" ").trim() || "Organizer";
            return {
              value: String(m._id),
              label,
              keywords: [m?.first_name, m?.last_name, m?.email_id, m?.phone_number].filter(Boolean).join(" "),
            };
          })}
          placeholder="— All —"
          searchPlaceholder="Search organizer…"
          allowEmpty={true}
          emptyLabel="— All —"
          maxVisibleItems={4}
          dropdownPortal={true}
          title="Hosted By filter"
        />
      </div>
    </>
  );
}
